module.exports = __webpack_public_path__ + "ferrero.png?372fbdbad7c3a82b7edea61a78e68969";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ferrero.png
// module id = 30
// module chunks = 0